import { DialogTitle, DialogActions, Button } from '@mui/material'

export const EditDialogTitle = ({ edit }) => (
    <DialogTitle style={{ minWidth: '400px' }}>
        {edit ? 'Editar configuração' : 'Nova configuração'}
    </DialogTitle>
);

export const TableDialogActions = ({ dialogClose, onSave }) => (
    <DialogActions>
        <Button variant="outlined" color="primary" onClick={dialogClose}>Cancelar</Button>
        <Button variant="outlined" color="primary" onClick={onSave} type="submit">Salvar</Button>
    </DialogActions>
);
